module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/score4.cd3735fc.png";